/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PackagePricingModeInputDto = {
    /**
     * Package mode
     */
    mode: PackagePricingModeInputDto.mode;
    /**
     * Price for single sessions (null/omitted = not set)
     */
    price_single?: number;
    /**
     * Price for duo sessions (null/omitted = not set or not supported)
     */
    price_duo?: number;
};
export namespace PackagePricingModeInputDto {
    /**
     * Package mode
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
}

